<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="contract_info"
                        arrows >
                    <template slot="gofixTab:contract_info">
                        <gofix-card title="Project Details" >
                            <template slot="gofixCard:right_header">
                                <div class="d-flex justify-content-end align-items-center">
                                    <span class="spanStatus mr-4">{{clientContract.status}}</span>
                                    <gofix-button
                                        small
                                        class="mr-3"
                                        label="Change Status"
                                        @click="modalStatus"
                                        :disabled="!$checkRole($accessModule.safety_app_project, 'update')" outline>
                                    </gofix-button>
                                    <span class="mr-2"><img src="img/icon-ellipse.png"></span>
                                    <b-button @click="print" class="mr-3 clientPrintIcon" title="Print" v-b-tooltip.hover><i class="icon-printer icons"></i></b-button>
                                    <!-- <b-button class="mr-4 clientPaperIcon" @click="activeDown = !activeDown" title="Attachment" v-b-tooltip.hover><i class="icon-paper-clip"></i><span class="badge">{{clientContract.main_contract.length + clientContract.terms_option.length + clientContract.extension_period_main.length + clientContract.extra_info.length + clientContract.contract_variation_info.length}}</span></b-button> -->
                                    <!-- <gofix-button
                                        small
                                        class="mr-3"
                                        label="update vendor linking"
                                        @click="updateVendorLinking"
                                        :loading="isActionVendor"
                                        :disabled="!$checkRole($accessModule.safety_app_project, 'update')" outline></gofix-button> -->
                                    <gofix-button
                                        small
                                        label="save"
                                        @click="checkChangeSupplier"
                                        :loading="disabled"
                                        :disabled="!$checkRole($accessModule.safety_app_project, 'update') || (clientContract.status !='Draft' && clientContract.status !='Reopening' && !isExpired)"></gofix-button>
                                </div>
                            </template>

                            <b-row>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                            label="Supplier"
                                            vLabel="name"
                                            :filterable="false"
                                            :append-to-body="true"
                                            required
                                            show-icon-required
                                            :disabled="isExpired"
                                            @search="searchOrganization"
                                            @change="selectClient"
                                            v-model="clientContract.supplier"
                                            :options="clients">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input label="Project Name" required show-icon-required :disabled="isExpired" v-model="clientContract.contract_title"></gofix-form-input>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-input label="Project Reference Number" required show-icon-required :disabled="isExpired" v-model="clientContract.contract_reference_number"></gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row v-for="(item, index) in clientContract.terms_base" :key="index">
                                <template v-if="index == 0">
                                    <b-col md="8">
                                        <gofix-form-input 
                                            label="Address" 
                                            v-model="clientContract.safety_address"
                                            :disabled="isExpired"
                                            autocomplete="off">
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                            :disabled="isExpired || clientContract.contract_terms.length > 1"
                                            v-model="item.start_date"
                                            label="Project Start Date">
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input-date
                                            :minDate="new Date()"
                                            :disabled="isExpired || clientContract.contract_terms.length > 1"
                                            v-model="item.end_date"
                                            label="Project End Date">
                                        </gofix-form-input-date>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Project Manager"
                                        vLabel="name"
                                        required
                                        show-icon-required
                                        @search="(search, loading) => searchSafetyUsers(search, loading, 'safety_project_managers')"
                                        v-model="clientContract.safety_project_manager"
                                        :options="safety_project_managers">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Project IC"
                                        vLabel="name"
                                        :disabled="isExpired"
                                        @search="(search, loading) => searchSafetyUsers(search, loading, 'safety_project_ics')"
                                        v-model="clientContract.safety_project_ic"
                                        :options="safety_project_ics">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Project Director"
                                        vLabel="name"
                                        :disabled="isExpired"
                                        @search="(search, loading) => searchSafetyUsers(search, loading, 'safety_project_directors')"
                                        v-model="clientContract.safety_project_director"
                                        :options="safety_project_directors">
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <b-row>
                                <!-- <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Project Description"
                                        vLabel="reference_value_text"
                                        :reduce="option => option.reference_value_text"
                                        v-model="clientContract.description"
                                        :options="project_descriptions">
                                    </gofix-form-dropdown>
                                </b-col> -->
                                <b-col md="8">
									<!-- <gofix-form-dropdown
										label="Department Head Email"
										v-model="clientContract.project_department_head_emails"
										:options="[]"
										:filterable="false"
										taggable
										pushTags
										multiple
                                        desc='Please enter the value and press the "Enter" button to add a new email address'
										noDrop>
									</gofix-form-dropdown> -->
                                    <gofix-form-input 
                                        label="Department Head Email" 
                                        v-model="clientContract.project_department_head_emails"
                                        :disabled="isExpired"
                                        autocomplete="off"
                                        desc="Separate multiple emails with comma">
                                    </gofix-form-input>
								</b-col>
                            </b-row>
                        
                            <!-- <b-row class="mt-10">
                                <b-col md="4">
                                    <gofix-form-input label="contract name" v-model="$v.clientContract.contract_name.$model" required></gofix-form-input>
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                    label="Supplier"
                                                    :disabled="true"
                                                    vLabel="name"
                                                    :filterable="false"
                                                    :clearable="false"
                                                    @search="searchOrganization"
                                                    @change="selectClient"
                                                    v-model="clientContract.supplier"
                                                    :options="clients">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input-number
                                                    :disabled="isContractProject"
                                                    v-if="clientContract.terms_base[0]"
                                                    label="Base Term Contract Sum"
                                                    v-model="clientContract.terms_base[0].contract_sum"
                                                    @change="changeSum"
                                                    prefix="$"></gofix-form-input-number>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                    :disabled="isContractProject"
                                                    v-if="clientContract.terms_base[0] && clientContract.terms_base[0].type"
                                                    label="SOR Adjustment Mark"
                                                    :options="adjustmentMark"
                                                    v-model="clientContract.terms_base[0].type"
                                                    :filterable="false">
                                            </gofix-form-dropdown>
                                            </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                    v-if="clientContract.terms_base && clientContract.terms_base[0] && clientContract.terms_base[0].extra_info"
                                                    v-model="clientContract.terms_base[0].extra_info.loaDate"
                                                    class="supplier-gofixInputHasDesc"
                                                    label="LOA date">
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                    v-if="clientContract.terms_base && clientContract.terms_base[0] && clientContract.terms_base[0].extra_info"
                                                    v-model="clientContract.terms_base[0].extra_info.agreementDate"
                                                    class="supplier-gofixInputHasDesc"
                                                    label="Agreement Signing Date">
                                            </gofix-form-input-date>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col md="6">
                                            <gofix-form-input-number
                                                    :disabled="isContractProject"
                                                    v-if="clientContract.terms_base[0]"
                                                    label="SOR adjustment (%)"
                                                    v-model="clientContract.terms_base[0].sor_adjustment"
                                                    :integer-limit="3"
                                                    suffix="%"></gofix-form-input-number>
                                        </b-col>
                                        <b-col md="6" class="content white-space-nowrap pt-20" v-if="clientContract.terms_base[0]">
                                            <label class="float-unset display-inline-block">Total Contract Sum</label> <div class="info-right">{{clientContract.terms_base[0] ? $accounting.formatMoney(clientContract.terms_base[0].total_contract_sum, { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '--'}}</div>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-input-number thousandsSeparatorSymbol="" decimalSymbol="" :integerLimit="null" label="contract Reference number" v-model="clientContract.contract_reference_number"></gofix-form-input-number>
                                        </b-col>
                                    </b-row>
                                    <b-row class="pt-20">
                                        <b-col md="5">
                                        </b-col>
                                        <b-col md="7">
                                            <gofix-button
                                                    class="mt-3 p-0"
                                                    label="Related Client Contracts"
                                                    @click="relatedContracts"
                                                    noBorder fontNormal></gofix-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row align-v="center">
                                <b-col md="2" :class="{'pt-20': !isContractProject}">
                                    <gofix-text-field label="S-Contract Type" oneline>{{ isContractProject ? 'Project' : 'Maintenance' }}</gofix-text-field>
                                </b-col>
                                <b-col md="6" v-if="isContractProject">
                                    <b-row align-v="center">
                                        <b-col md="4">
                                            <gofix-form-dropdown
                                                    label="Project type"
                                                    vLabel="reference_value_text"
                                                    :reduce="option => option.reference_value_text"
                                                    v-model="clientContract.project_type"
                                                    :options="projectTypes">
                                                </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="8">
                                            <gofix-text-field label="Project Expiry Date" oneline>{{ showProjectExpiryDate }}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4" class="content white-space-nowrap pt-20">
                                    <label class="float-unset display-inline-block">Creditor Code</label> <div class="info-right">{{ getCreditorCode }}</div>
                                    <div class="property-dropdown dropdown-custom-tooltip">
                                        <gofix-form-dropdown
                                            label="Creditor Code"
                                            append-to-body
                                            :filterable="false"
                                            v-model="clientContract.creditor_code"
                                            vLabel="source_code"
                                            :reduce="option => option.source_code"
                                            :options="creditorCodeOptions"
                                            @search="loadCreditorCode">
                                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                            </template>
                                            <template #gofixInput:dropdown:option="option">
                                                        <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                                            </template>
                                        </gofix-form-dropdown>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="mt-10" v-if="!isContractProject">
                                <b-col md="12">
                                    <div class="btnGroupPlus">
                                        <gofix-button class="mr-3" label="option period +" @click="addOption('terms_option', 'option')" outline></gofix-button>
                                        <gofix-button class="mr-3" label="extension period +" @click="addOption('extension_period_main', 'extension')" outline></gofix-button>
                                        <gofix-button class="mr-3" label="add security deposit +" @click="addOption('extra_info', 'extra_info')" outline></gofix-button>
                                        <gofix-button label="add contract vari. +" @click="addOption('contract_variation_info', 'contract_variation_info')" outline></gofix-button>
                                    </div>
                                </b-col>
                            </b-row> -->
                        </gofix-card>

                        <!-- Attachment -->
                        <!-- <contract-attachment :is_active="activeDown" :contract="clientContract"></contract-attachment> -->

                        <terms-option :terms-option="clientContract.terms_option" @removeItem="removeOption"></terms-option>
                        <extension-period :value="clientContract.extension_period_main" @removeItem="removeOption"></extension-period>
                        <extra-info :value="clientContract.extra_info" @removeItem="removeOption" @clone="clonePublic"></extra-info>
                        <variation-info :value="clientContract.contract_variation_info" @removeItem="removeOption"></variation-info>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="SOR Adjustment" hide-footer hide-header :centered="true" ref="modal-change-sor">
            <div class="center">SOR items unit price will be re-calculated
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$refs['modal-change-sor'].hide()">Cancel</b-button>
                <b-button class="custom-btn" @click="saveClientContract">
                    Continue
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="Related Contracts" ref="search-client" id="search-client" hide-footer>
            <ul class="list-unstyled related-contract" v-if="relatedContract.total > 0" v-bind:class="{'run-loading':Loadings.list}">
                <template v-for="(item, index) in relatedContract.data">
                    <li v-bind:key="item.id">
                        <router-link :to="`/v2/contract-client/${item.id}`" class="custom-link">
                            {{ item.contract_name }}
                            <small>{{ item.client && item.client.name ? item.client.name : '--' }}</small>
                            <small>From: {{ item.terms_base[0].start_date | formatsDate }} to {{ item.terms_base[0].end_date | formatsDate }}</small>
                        </router-link>
                    </li>
                </template>
            </ul>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Change Status" hide-footer :centered="true" ref="modal-Status">
            <b-form>
                <gofix-form-dropdown
                    label=""
                    :required="true"
                    :clearable="false"
                    v-model="contract_status"
                    :options="contractStatus[clientContract.status]">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="updateStatus" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <contract-print :client-contract="clientContract" ref="contractPrint"></contract-print>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.confirm.open">
            <div class="py-4 px-1">
                Are you sure you want to change the <strong>supplier</strong>? <br/>
                Once changed, all users from the previous supplier will be removed from the <strong>Supplier Staff</strong> tab.
            </div>
            <b-button-group class="btn-group">
            <b-button class="custom-btn" @click="modals.confirm.open = false">Cancel</b-button>
            <b-button class="custom-btn" @click="saveClientContract" :disabled="modals.confirm.loading">
                <b-spinner v-if="modals.confirm.loading" small type="grow"></b-spinner>Confirm
            </b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'
    const contractAttachment = () => import("@/views/contracts/contract-attachment_v2")
    const contractPrint = () => import("@/views/contracts/main-info/print")
    const termsOption = () => import("@/views/contracts/main-info/terms_option")
    const extensionPeriod = () => import("@/views/contracts/main-info/extension_period")
    const extraInfo = () => import("@/views/contracts/main-info/extra_info")
    const variationInfo = () => import("@/views/contracts/main-info/variation_info")
    import tabData from '@/data/_tabs';

    import moment from 'moment';
    var accounting = require('accounting');
    export default {
        name: 'contract-info',
        components: {
            contractAttachment,
            contractPrint,
            termsOption,
            extensionPeriod,
            extraInfo,
            variationInfo
        },
        data () {
            return {
                contract_tab: tabData.safety_projects,
                isActionVendor: false,
                activeDown: true,
                disabled: false,
                i: 0,
                clients: [],
                clientsSupplier: [],
                infoSORAdjustment: null,
                clientContract: {
                    checkSORAdjustment: false,
                    client: null,
                    client_id: 1,
                    terms_base: [],
                    terms_option: [],
                    main_contract: [],
                    option_period: [],
                    extention_period: [],
                    security_deposit: [],
                    work_injury_compensation: [],
                    public_liability_claim_insurence: [],
                    contract_variation: [],
                    extension_period_main: [],
                    extra_info: [],
                    contract_variation_info: [],
                    creditor_code: '',
                    is_supplier_under_lmu_project: false,
                    project_department_head_emails: null,
                    safety_project_manager: null,
                    safety_project_ic: null,
                    safety_project_director: null,
                },
                isAction: false,
                contractStatus:{
                    Draft : ['Draft','Active'],
                    Active : ['Draft','Active','Terminated','Reopening'],
                    Terminated : ['Draft','Active','Terminated','Reopening'],
                    Reopening : ['Draft','Active','Reopening'],
                },
                contract_status: null,
                supplier: {
                    contract_id : '',
                    client_id: '',
                    sor_adjustment: '',
                },
                listIDSupplierRelated: [],
                extra_info_ids: [],
                adjustmentMark: [
                    {
                      value: 'up',
                      label: 'Mark Up'
                    },
                    {
                      value: 'down',
                      label: 'Mark Down'
                    }
                ],
                creditorCodeOptions:[],
                projectTypes: [],
                safety_project_managers: [],
                safety_project_ics: [],
                safety_project_directors: [],
                project_descriptions: [],
                modals:{
                    confirm: {
                        open: false,
                        loading: false
                    },
                },
            }
        },
        mixins: [validationMixin],
        validations: {
            clientContract: {
                contract_name: {
                    required
                },
                supplier: {
                    required
                },
                contract_reference_number: {
                    required
                }
            }
        },
        computed: {
            ...mapGetters({
                Loadings: 'ContractController/Loadings',
                ListSupplierContract: 'ContractController/ListSupplierContract',
                relatedContract: 'ContractController/relatedSupplier',
                SContract: "ContractController/SContract",
            }),
            getCreditorCode() {
                var creditor_code = '';
                var source_description = '';
                if(this.clientContract.supplier && this.clientContract.supplier.vendor_linking_creditor_code) {
                    if(this.clientContract.client_contract && this.clientContract.client_contract.finance_company && this.clientContract.client_contract.finance_company.company && this.clientContract.client_contract.finance_company.company.id) {
                        const arrTmp = this.clientContract.supplier.vendor_linking_creditor_code.filter(item => item.coa_companie_id == this.clientContract.client_contract.finance_company.company.id);
                        if(arrTmp.length) {
                            creditor_code = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_code ? arrTmp[0].creditor_code.source_code : '';
                            source_description = arrTmp[0].creditor_code && arrTmp[0].creditor_code.source_description ? (" - " + arrTmp[0].creditor_code.source_description) : '';
                        }
                    }
                }

                if(creditor_code) return creditor_code + source_description;
                return;
            },
            isExpired() {
                return this.clientContract.status == 'Expired';
            },
            isContractProject() {
                // if(this.clientContract && this.clientContract.contract_terms && this.clientContract.contract_terms.length) {
                //     let obj = this.clientContract.contract_terms.filter(item => item.term_type == 'project');
                //     if(obj.length) return true;
                // }
                return false;
            },
            showProjectExpiryDate() {
                if(this.clientContract && this.clientContract.contract_terms && this.clientContract.contract_terms.length) {
                    let obj = this.clientContract.contract_terms.filter(item => item.term_type == 'project');
                    if(obj.length) {
                        return obj[0].end_date ? moment(new Date(obj[0].end_date)).format("DD.MM.YYYY") : '';
                    }
                }
                return '';
            }
        },
        filters: {
            formatsDate: function(value) {
                if (!value) return "N/A";
                return moment(new Date(value)).format("DD.MM.YYYY");
            }
        },
        watch: {},
        created() {
            if(!this.$route.params.hasOwnProperty('id') && isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/safety-app-project`)
            }
            
            this.getContract();
            // this.getProjectDescriptions();
            this.loadSafetyUser().then(users => {
                this.safety_project_managers = users;
                this.safety_project_ics = users;
                this.safety_project_directors = users;
            });
            this.getOrganization();
            // this.loadCreditorCode();
            // this.getProjectType();
        },
        methods: {
            getContract() {
                this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                .then(response => {
                    this.setContractInfo(response.data.data)
                })
                .catch(error => { 
                    this.$router.push(`/v2/safety-app-project`) 
                })
            },
            formatData(temp, type ="base") {
                if(!temp || !temp.length) {
                    if(type == 'base') {
                        temp.push({
                            id: '',
                            term_type: type,
                            start_date: null,
                            end_date: null,
                            contract_sum: '',
                            sor_adjustment: '',
                            data: {}
                        });
                    }
                    return;
                }

                if(type == 'contract_variation_info') {
                    temp.forEach(function(item) {
                        item.json_content.amount = JSON.stringify(item.json_content.amount)
                    });
                    return;
                }

                //type: extra_info
                if(type == "extra_info") {
                    temp.forEach(function(item) {
                        //Security deposit
                        item.security_deposit.json_content.amount = JSON.stringify(item.security_deposit.json_content.amount);
                        //Work injury compensation
                        item.work_injury_compensation.json_content.policy_premium = JSON.stringify(item.work_injury_compensation.json_content.policy_premium)
                        item.work_injury_compensation.json_content.issue_date = item.work_injury_compensation.json_content.issue_date ? new Date(moment(item.work_injury_compensation.json_content.issue_date, "YYYY-MM-DD").toISOString()) : null;
                        item.work_injury_compensation.json_content.start_date = item.work_injury_compensation.json_content.start_date ? new Date(moment(item.work_injury_compensation.json_content.start_date, "YYYY-MM-DD").toISOString()) : null;
                        item.work_injury_compensation.json_content.end_date = item.work_injury_compensation.json_content.end_date ? new Date(moment(item.work_injury_compensation.json_content.end_date, "YYYY-MM-DD").toISOString()) : null;

                        //Public liability claim insurance
                        item.public_liability_claim_insurance.json_content.policy_premium = JSON.stringify(item.public_liability_claim_insurance.json_content.policy_premium)
                        item.public_liability_claim_insurance.json_content.issue_date = item.public_liability_claim_insurance.json_content.issue_date ? new Date(moment(item.public_liability_claim_insurance.json_content.issue_date, "YYYY-MM-DD").toISOString()) : null;
                        item.public_liability_claim_insurance.json_content.start_date = item.public_liability_claim_insurance.json_content.start_date ? new Date(moment(item.public_liability_claim_insurance.json_content.start_date, "YYYY-MM-DD").toISOString()) : null;
                        item.public_liability_claim_insurance.json_content.end_date = item.public_liability_claim_insurance.json_content.end_date ? new Date(moment(item.public_liability_claim_insurance.json_content.end_date, "YYYY-MM-DD").toISOString()) : null;
                    });
                    return;
                }

                temp.forEach((item)  => {
                    item.contract_sum   = (item.contract_sum === 0 || !item.contract_sum) ?  '' : this.$accounting.formatMoney(item.contract_sum);
                    item.start_date     = (item.start_date != null) ? new Date(item.start_date) : null
                    item.end_date       = (item.end_date != null) ? new Date(item.end_date) : null
                    item.sor_adjustment = (item.sor_adjustment != null) ? parseFloat(parseFloat((item.sor_adjustment)*100).toFixed(2)) + "" : null;

                    if (item.extra_info) {
                        if (item.extra_info.loaDate) {
                            item.extra_info.loaDate = (item.extra_info.loaDate != null) ? new Date(item.extra_info.loaDate) : null;
                        }
                        if (item.extra_info.agreementDate) {
                            item.extra_info.agreementDate = (item.extra_info.agreementDate != null) ? new Date(item.extra_info.agreementDate) : null;
                        }
                        if (item.extra_info.clientLetterDate) {
                            item.extra_info.clientLetterDate = (item.extra_info.clientLetterDate != null) ? new Date(item.extra_info.clientLetterDate) : null;
                        }
                    }

                    let val = {
                        value: 'up',
                        label: 'Mark Up'
                    };

                    if(item.sor_adjustment < 0) {
                        item.sor_adjustment = item.sor_adjustment.replace("-", "")
                        val.value = 'down';
                        val.label = 'Mark Down';
                    }

                    item.type = val;
                });
            },
            setContractInfo(contract) {
                if (contract != null) {
                    this.infoSORAdjustment = contract.terms_base[0] ? contract.terms_base[0].sor_adjustment : null;
                    this.formatData(contract.terms_base, 'base');
                    this.formatData(contract.terms_option, 'option');
                    this.formatData(contract.extension_period_main, 'extension_period_main');
                    this.formatData(contract.extra_info, 'extra_info');
                    this.formatData(contract.contract_variation_info, 'contract_variation_info');
                    contract.project_department_head_emails = contract.project_department_head_emails && contract.project_department_head_emails.length ? contract.project_department_head_emails.join(","): null
                    this.clientContract = Object.assign({}, contract)
                    this.clientContract.contract_id = contract.id
                }
                this.clientContract.security_deposit_main  = []
                this.clientContract.contact_variation_main = []
            },
            addOption(key, type = 'option') {
                if(!this.clientContract[key]) return;
                let val = {
                    contract_id: this.$route.params.id,
                    id: null,
                    type: {
                        value: 'up',
                        label: 'Mark Up'
                    },
                    term_type: type,
                    start_date: null,
                    end_date: null,
                    contract_sum: '',
                    sor_adjustment: '',
                    extra_info: {}
                }

                if(type == 'extra_info') {
                    val = {
                        security_deposit : {
                            id: '',
                            section_name: 'Security Deposit',
                            json_content: {
                                type: '',
                                issuing_bank: '',
                                cheque_number: '',
                                amount: ''
                            }
                        },
                        work_injury_compensation: {
                            id: '',
                            section_name: 'Work Injury Compensation',
                            json_content: {
                                insurer: '',
                                policy_number: '',
                                issue_date: null,
                                policy_premium: '',
                                start_date: null,
                                end_date: null,
                                policy_receipt: ''
                            }
                        },
                        public_liability_claim_insurance: {
                            id: '',
                            section_name: 'Public Liability Claim Insurance',
                            json_content: {
                                insurer: '',
                                policy_number: '',
                                issue_date: null,
                                policy_premium: '',
                                start_date: null,
                                end_date: null,
                                policy_receipt: '',
                                copy_info_from: ''
                            }
                        }
                    };
                }

                if(type == 'contract_variation_info') {
                    val = {
                        id: '',
                        section_name: 'Contract Variation',
                        json_content: {
                            amount: '',
                            description: ''
                        }
                    };
                }
                
                this.clientContract[key].push(val)
            },
            removeOption(key, index, item = null) {
                if(!this.clientContract[key] || !this.clientContract[key].length) return;
                if(key == 'extra_info') {
                    if(item && item.security_deposit && item.security_deposit.id != 0) {
                        this.extra_info_ids.push(item.security_deposit.id);
                        this.extra_info_ids.push(item.work_injury_compensation.id);
                        this.extra_info_ids.push(item.public_liability_claim_insurance.id);
                    }
                }
                if(key == 'contract_variation_info' && item && item.id) {
                    this.extra_info_ids.push(item.id);
                }
                if(key == 'terms_option' && item && item.id){
                    if(this.clientContract.contract_term_id == item.id){
                        return this.$alertNotification("Can't delete term actived.", "danger");
                    }
                }
                if(key == 'extension_period_main' && item && item.id){
                    if(this.clientContract.contract_term_id == item.id){
                        return this.$alertNotification("Can't delete term actived.", "danger");
                    }
                }
                this.$delete(this.clientContract[key], index)
            },
            updateStatus() {
                if(this.isAction) return;
                if(!this.contract_status) {
                    return this.$alertNotification("Status is required.", "danger");
                }
                this.isAction = true;
                this.$store.dispatch('ContractController/updateStatusScontract', { contract_id: this.clientContract.id, status: this.contract_status })
                    .then(response => {
                        this.isAction = false;
                        this.clientContract.status = this.contract_status;
                        this.$refs['modal-Status'].hide();
                        return this.$alertNotification(this.$notificationV2('editing', 'supplier_contract'));
                    })
                    .catch(error => {
                        this.isAction = false;
                    });
            },
            modalStatus() {
                this.contract_status = this.clientContract.status
                this.$refs['modal-Status'].show();
            },
            async getOrganization(search = null) {
                await this.$store.dispatch( 'OrganizationController/getItemsNoCommit', {
                    page: 1, 
                    isCMS: 1,
                    filter: { 
                        name: { type: "text", value: search, function: "ilike", with: [] },
                        is_supplier: { type: 'boolean', value: true },
                        is_safety: { type: 'boolean', value: true },
                    }, 
                    limit: 100
                })
                .then(response => {
                    this.clients = response.data.data.items;
                })
                .catch(err=>{ })
            },
            searchOrganization(search, loading){
                this.clients = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOrganization(search);
                        loading(false)
                    } catch (err) {
                        loading(false)
                    }
                }, 500);
            },
            selectClient(val) {
                if(val) {
                    this.clientContract.supplier = val
                    this.clientContract.supplier_id = val.id
                }
            },
            checkSORAdjustment() {
                this.clientContract.checkSORAdjustment = false;
                if(this.clientContract.terms_base[0]) {
                    let check = this.infoSORAdjustment !== null ? this.infoSORAdjustment * 100 : 0
                    let checknew = this.clientContract.terms_base[0].sor_adjustment !== null ? Math.abs(this.clientContract.terms_base[0].sor_adjustment) : 0;
                    if(this.clientContract.terms_base[0].type && this.clientContract.terms_base[0].type.value && this.clientContract.terms_base[0].type.value == "down") {
                        checknew = checknew * -1;
                    }
                    if(this.checkMarDownValue(checknew)) {
                        return this.$alertNotification("Mark Down: can't input SOR Adjustment > 100%", "danger");
                    }
                    if(checknew != check){
                        this.clientContract.checkSORAdjustment = true;
                        this.$refs['modal-change-sor'].show()
                        return
                    }
                }
                this.saveClientContract()
            },
            validattionDate() {
                /* Validate */
                let flag = false;

                if(this.clientContract.project_department_head_emails ) {
                    const emails = this.clientContract.project_department_head_emails.split(",").map(email => email.trim());
                    for(let i = 0; i < emails.length; i++) {
                        if(!this.emailValidationCheckFormat(emails[i])) {
                            flag = true;
                            this.$alertNotification(`Please enter a valid email address for Department Head Email: ${emails[i]}`, "danger");
                            break;
                        }
                    }
                }

                if(!this.clientContract.safety_project_manager) {
                    flag = true;
                    this.$alertNotification("Project Manager is required", "danger");
                }

                return flag;
            },
            saveClientContract() {
                this.$v.clientContract.$touch()
                if(!this.$v.clientContract.$error){
                    let is_unvalid = this.validattionDate();
                    if(is_unvalid) {
                        return;

                    }

                    
                    if(this.modals.confirm.open) {
                        this.modals.confirm.loading = true
                    } else {
                        this.disabled = true
                    }

                    let contractRequest = JSON.parse(JSON.stringify(this.clientContract));
                    contractRequest.settings = JSON.stringify(contractRequest.settings);
                    contractRequest.lmu_settings = JSON.stringify(contractRequest.lmu_settings);
                    contractRequest.extra_info_ids = this.extra_info_ids

                    delete contractRequest.maintenance_settings
                    delete contractRequest.case_hot_button_settings

                    if (contractRequest.terms_base.length > 0) {
                        contractRequest.terms_base.forEach((obj) => {
                            obj.contract_sum = accounting.unformat(obj.contract_sum)
                            obj.start_date = (obj.start_date != null) ? moment(new Date(obj.start_date)).format('YYYY-MM-DD') : ''
                            obj.end_date = (obj.end_date != null) ? moment(new Date(obj.end_date)).format('YYYY-MM-DD') : '';
                            if(obj.type.value === 'down'){
                                obj.sor_adjustment = '-'+obj.sor_adjustment
                            }
                            delete(obj.type)
                        });
                    }

                    if (contractRequest.terms_option.length > 0) {
                        contractRequest.terms_option.forEach(function(obj) {
                            obj.contract_sum = accounting.unformat(obj.contract_sum)
                            obj.start_date = (obj.start_date != null) ? moment(new Date(obj.start_date)).format('YYYY-MM-DD') : ''
                            obj.end_date = (obj.end_date != null) ? moment(new Date(obj.end_date)).format('YYYY-MM-DD') : ''
                            if(obj.type.value === 'down'){
                                obj.sor_adjustment = '-'+obj.sor_adjustment
                            }
                            delete(obj.type)
                        });
                    }

                    if (contractRequest.extension_period_main.length > 0) {
                        contractRequest.extension_period_main.forEach(function(obj) {
                            obj.contract_sum = accounting.unformat(obj.contract_sum)
                            obj.start_date = (obj.start_date != null) ? moment(new Date(obj.start_date)).format('YYYY-MM-DD') : ''
                            obj.end_date = (obj.end_date != null) ? moment(new Date(obj.end_date)).format('YYYY-MM-DD') : ''
                            if(obj.type.value === 'down'){
                                obj.sor_adjustment = '-'+obj.sor_adjustment
                            }
                            delete(obj.type)
                        });
                    }

                    if (contractRequest.extra_info.length > 0) {
                        let extra_info = [];
                        contractRequest.extra_info.forEach(function(obj) {
                            //Security deposit
                            obj.security_deposit.json_content.amount = accounting.unformat(obj.security_deposit.json_content.amount)
                            //Work injury compensation
                            obj.work_injury_compensation.json_content.policy_premium = accounting.unformat(obj.work_injury_compensation.json_content.policy_premium)
                            obj.work_injury_compensation.json_content.issue_date = obj.work_injury_compensation.json_content.issue_date ? moment(new Date(obj.work_injury_compensation.json_content.issue_date)).format('YYYY-MM-DD') : '';
                            obj.work_injury_compensation.json_content.start_date = obj.work_injury_compensation.json_content.start_date ? moment(new Date(obj.work_injury_compensation.json_content.start_date)).format('YYYY-MM-DD') : '';
                            obj.work_injury_compensation.json_content.end_date = obj.work_injury_compensation.json_content.end_date ? moment(new Date(obj.work_injury_compensation.json_content.end_date)).format('YYYY-MM-DD') : '';

                            //Public liability claim insurance
                            obj.public_liability_claim_insurance.json_content.policy_premium = accounting.unformat(obj.public_liability_claim_insurance.json_content.policy_premium)
                            obj.public_liability_claim_insurance.json_content.issue_date = obj.public_liability_claim_insurance.json_content.issue_date ? moment(new Date(obj.public_liability_claim_insurance.json_content.issue_date)).format('YYYY-MM-DD') : '';
                            obj.public_liability_claim_insurance.json_content.start_date = obj.public_liability_claim_insurance.json_content.start_date ? moment(new Date(obj.public_liability_claim_insurance.json_content.start_date)).format('YYYY-MM-DD') : '';
                            obj.public_liability_claim_insurance.json_content.end_date = obj.public_liability_claim_insurance.json_content.end_date ? moment(new Date(obj.public_liability_claim_insurance.json_content.end_date)).format('YYYY-MM-DD') : '';

                            obj.security_deposit.json_content = JSON.stringify(obj.security_deposit.json_content)
                            obj.work_injury_compensation.json_content = JSON.stringify(obj.work_injury_compensation.json_content)
                            obj.public_liability_claim_insurance.json_content = JSON.stringify(obj.public_liability_claim_insurance.json_content)
                            extra_info.push(obj.security_deposit)
                            extra_info.push(obj.work_injury_compensation)
                            extra_info.push(obj.public_liability_claim_insurance)
                        });
                        contractRequest.extra_info = extra_info;
                    }

                    if(contractRequest.contract_variation_info.length > 0) {
                        contractRequest.contract_variation_info.forEach(function(obj) {
                            obj.json_content.amount = accounting.unformat(obj.json_content.amount)
                            obj.json_content = JSON.stringify(obj.json_content)
                        });
                    }

                    contractRequest.deposit_expiry = (contractRequest.deposit_expiry != null) ? contractRequest.deposit_expiry.toISOString().split('T')[0] : '';
                    contractRequest.insurance_expiry = (contractRequest.insurance_expiry != null) ? contractRequest.insurance_expiry.toISOString().split('T')[0] : '';

                    contractRequest.project_department_head_emails = []
                    if(this.clientContract.project_department_head_emails) {
                        const emails = this.clientContract.project_department_head_emails.split(",").map(email => email.trim());
                        contractRequest.project_department_head_emails = emails;
                    }

                    if(contractRequest.safety_project_manager) {
                        contractRequest.safety_project_manager_id = contractRequest.safety_project_manager.id
                    }

                    if(contractRequest.safety_project_ic) {
                        contractRequest.safety_project_ic_id = contractRequest.safety_project_ic.id
                    }

                    if(contractRequest.safety_project_director) {
                        contractRequest.safety_project_director_id = contractRequest.safety_project_director.id
                    }

                    this.$store.dispatch('ContractController/UpdateSupllierContract', contractRequest)
                        .then(response => {
                            this.modals.confirm.open = false
                            this.$refs['modal-change-sor'].hide()
                            this.getContract();
                            this.$store.dispatch('ContractController/getListSupplierContracts', [this.ListSupplierContract.currentPage, this.ListSupplierContract.filter, this.ListSupplierContract.limit, '1'] )
                            if(response.data.status == 200) {
                                this.$nextTick(() => {
                                    this.$v.clientContract.$reset()
                                })
                                return this.$alertNotification(this.$notificationV2('editing', 'supplier_contract'));
                            }
                        })
                        .catch(error => {
                            if(error.response) this.$alertNotification(error, "danger");
                        }).finally(() => {
                            this.disabled = this.modals.confirm.loading = false
                        });
                }
            },
            checkMarDownValue(val, max_val = 100) {
                if(accounting.unformat(val) > 100) return true;
                return false;
            },
            relatedSuppliers() {
                if (this.$route.params.id != this.relatedSupplier.contract_id || this.clientContract.related_supplier_contracts_count != this.relatedSupplier.total) {
                    this.$store.dispatch('ContractController/getRelatedSupplier', {
                        contract_id: this.$route.params.id,
                        contract_type: 's_contract'
                    })
                        .then(response=>{
                            if(this.relatedSupplier.data) {
                                const _this = this;
                                this.relatedSupplier.data.map(function(item) {
                                    _this.listIDSupplierRelated.push(item.supplier_id);
                                });
                            }
                        })
                }
                this.$bvModal.show('search-client')
            },
            selectOrganization(val){
                this.supplier.client_id = (val && val.hasOwnProperty('id')) ? val.id : ''
            },
            relatedContracts() {
                if(this.$route.params.id != this.relatedContract.contract_id) {
                    this.$store.dispatch( 'ContractController/getRelatedSupplier', { contract_id: this.$route.params.id, contract_type: 'c_contract' } )
                }
                this.$refs['search-client'].show()
            },
            clonePublic(index) {
                if(this.clientContract.extra_info[index]) {
                    this.clientContract.extra_info[index].public_liability_claim_insurance.json_content = JSON.parse(JSON.stringify(this.clientContract.extra_info[index].work_injury_compensation.json_content));
                    this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.copy_info_from = new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.copy_info_from)
                    this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.issue_date = this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.issue_date ? new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.issue_date) : null
                    this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.start_date = this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.start_date ? new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.start_date) : null
                    this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.end_date = this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.end_date ? new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.end_date) : null
                    return
                }
            },
            print () {
                this.$refs.contractPrint.print();
            },
            updateVendorLinking() {
                if(this.isActionVendor) {
                    return;
                }
                this.isActionVendor = true
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('ContractController/updateVendorLinking', {
                        supplier_contract_id: this.$route.params.id
                    })
                        .then(response => {
                            this.isActionVendor = false
                            return this.$alertNotification(this.$notificationV2('editing', 'vendor_linking'));
                        })
                        .catch(error => {
                            this.isActionVendor = false
                            if(error.response) this.$alertNotification("Error!", "danger");
                        })
                }, 300)
            },
            changeSum(e){
                /*if(this.clientContract.terms_base[0]) {
                  let a = e.target.value
                  this.clientContract.terms_base[0].total_contract_sum = accounting.unformat(a)
                }*/
            },
            loadCreditorCode(search = null){
                let filter = {
                    source_type: "S",
                    is_blocked: 0,
                    source_code: search || null,
                    contract_id: this.clientContract ? this.clientContract.id : null,
                };
                let params = {
                  filter: filter,
                  limit: 50,
                  sortColumn: "source_code",
                  sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                    .then(response => {
                      this.creditorCodeOptions = response.items;
                    })
            },
            getProjectType() {
                this.$store.dispatch(`PropertyController/getReferences`, {
                    filter: { reference_type: 'Project Type' },
                    limit: -1,
                    isCMS: true
                })
                .then(response => {
                    this.projectTypes = response.data.data.items
                })
                .catch(error => {
                    reject(error);
                })
            },
            emailValidationCheckFormat(email_address){
                if(email_address && email_address != ''){
                    let pattern = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
                    let result = pattern.test(email_address);
                    return result;
                }
                return true;
            },
            loadSafetyUser(search){
                return new Promise((resolve, reject) => {
                    this.$store.dispatch("v2UserController/getListUser2", {
                        filter: {
                            type_user:"all-safety",
                            name: { type: "text", value: search, function: "like", with: [] },
                            active:{ type: "boolean", value: true },
                            is_safety: { type: "boolean", value: true },
                        },
                        isCMS: 1,
                        page: 1,
                        limit: 100,
                        sortColumn: "name",
                        sortDirection: "asc",
                    }).then(response => {
                        resolve(response.items);
                    })
                    .catch(err=>{
                        console.log(err)
                        reject(err);
                    })
                })
            },
            searchSafetyUsers(search, loading, userType){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.loadSafetyUser(search).then(safetyUsers => {
                        this[userType] = safetyUsers;
                        loading(false);
                    })
                }, 500);
            },
            getProjectDescriptions(){
                let filter = {reference_type: "Safety Project Description"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.project_descriptions = response.items;
                    })
            },
            checkChangeSupplier() {
                if(this.clientContract.supplier && this.clientContract.supplier.id && this.clientContract.supplier.id != this.SContract.supplier_id) {
                    this.modals.confirm.open = true;
                    return;
                }
                this.saveClientContract()
            }
        }
    }
</script>
